module.exports = __webpack_public_path__ + "img/protect.7bc75064.svg";